export default {
  AFD_MESSAGE: "afd_message",
  CUSTOMER: "customer",
  DAMAGE: "damage",
  EMAIL: "email",
  MORTGAGE: "mortgage",
  POLICY: "policy",
};
